import { forwardRef } from "react";

import { Box, StackProps, Stack, useTheme } from "@mui/material";

import { mergeSx } from "@/helpers/mergeSx";

export type StorybookConfirmationDialogPreviewProps = StackProps;

export const StorybookConfirmationDialogPreview = forwardRef<HTMLDivElement, StorybookConfirmationDialogPreviewProps>(
  ({ sx, children, ...rest }, ref) => {
    const theme = useTheme();

    return (
      <Box sx={{ padding: { xs: 2, md: 4 }, backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
        <Stack
          ref={ref}
          {...rest}
          sx={mergeSx(
            {
              maxWidth: 444,
              maxHeight: 336,
              marginInline: "auto",
              backgroundColor: theme.palette.formsComponents.dialog.backgroundColor,
              borderRadius: theme.radius(1),
              boxShadow: theme.shadows[8],
            },
            sx
          )}
        >
          {children}
        </Stack>
      </Box>
    );
  }
);

StorybookConfirmationDialogPreview.displayName = "StorybookConfirmationDialogPreview";
